import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";

const Footer = ({ className = "bg-light text-dark" }) => {
  return (
    <footer className={`py-2 ${className}`}>
      <Container>
        <Row>
          <Col xs={12} md={12}>
            <div className="text-center text-md-left footer-text flex-column flex-md-row gap-md-1 justify-content-md-center">
            <span className="copyright">
                Copyright &copy; {new Date().getFullYear()} New York City Public Schools.
              </span>{" "}
              <span className="disclaimer">
                <span className="fw-400">Note:</span> This application relies on machine translation.
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;

